function goAnchor(anchor) {
  // var anchor = this.$el.querySelector(selector);//获取元素
  // let anchor = document.getElementById(selector);
  let height = anchor.offsetTop; //计算需要向上移动的距离
  if (anchor) {
    setTimeout(()=>{//页面没有渲染完成时是无法滚动的，因此设置延迟
    // anchor.scrollIntoView(); //js的内置方法，可滚动视图位置至元素位置
    window.scroll({
      top: height - 78, //向上移动的距离，如果有fixede布局， 直接减去对应距离即可
      behavior: 'smooth', // 平滑移动
    });

    },100);
  }
};

//获取参数
function GetQueryString() {
  var r = window.location.href;
  let href = r.split("#")[1]
  if (href) {
    return href
  } else {
    return null
  }
}
export {
  goAnchor,
  GetQueryString
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js